import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const TRIGGER_PX = 80 // matches --header-unit-height (4.444rem at 18px base)
const DURATION = 0.5
const EASE = 'power2.inOut'

let trigger: ScrollTrigger | null = null
let tl: gsap.core.Timeline | null = null

export const destroyHeaderIconSwap = () => {
  if (trigger) {
    trigger.kill()
    trigger = null
  }
  if (tl) {
    tl.kill()
    tl = null
  }
}

export const initHeaderIconSwap = () => {
  destroyHeaderIconSwap()

  const track = document.querySelector<HTMLElement>(
    '.header-menu-main__icon-swap-track'
  )
  if (!track) return

  const clip = track.closest<HTMLElement>('.header-menu-main__icon-swap')
  if (!clip) return

  const itemHeight = clip.getBoundingClientRect().height

  tl = gsap.timeline({ paused: true })
  tl.to(track, {
    y: -itemHeight,
    duration: DURATION,
    ease: EASE,
  })

  trigger = ScrollTrigger.create({
    start: `${TRIGGER_PX} top`,
    end: 'max',
    onEnter: () => tl!.play(),
    onLeaveBack: () => tl!.reverse(),
  })

  // Handle already-scrolled state (page reload, ASwap navigation)
  if (window.scrollY >= TRIGGER_PX) {
    tl.progress(1)
  }
}
